import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const YhKvkkTextsDialog = ({ open, onClose }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) api.get("/admin/yh/kvkk-texts").then(({ data }) => setF(data)).catch(() => toast.error("Metinler yüklenemedi"));
  }, [open]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/yh/kvkk-texts", { aydinlatma_text: f.aydinlatma_text, acik_riza_text: f.acik_riza_text, legal_review_done: !!f.legal_review_done });
      setF({ ...data, is_default: false });
      toast.success(`Metinler kaydedildi (sürüm ${data.version})`);
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="yh-kvkk-dialog">
        <DialogHeader><DialogTitle>KVKK Metinleri (Model 3)</DialogTitle></DialogHeader>
        {!f ? <div className="text-sm text-muted-foreground">Yükleniyor…</div> : (
          <div className="space-y-3">
            <div className="text-xs rounded-lg bg-amber-50 border border-amber-200 p-2 text-amber-800" data-testid="yh-kvkk-status">
              Sürüm {f.version}{f.is_default ? " (varsayılan taslak, henüz kaydedilmedi)" : ""} · {f.legal_review_done && !f.is_default ? "Hukuki inceleme tamamlandı olarak işaretli — onay bağlantıları oluşturulabilir." : "Hukuki inceleme tamamlanmadı — müşteriye onay bağlantısı gönderilemez."}
            </div>
            <div><Label>Aydınlatma metni</Label><Textarea rows={9} className="mt-1 text-xs" value={f.aydinlatma_text} onChange={(e) => setF({ ...f, aydinlatma_text: e.target.value })} data-testid="yh-kvkk-aydinlatma" /></div>
            <div><Label>Açık rıza metni</Label><Textarea rows={7} className="mt-1 text-xs" value={f.acik_riza_text} onChange={(e) => setF({ ...f, acik_riza_text: e.target.value })} data-testid="yh-kvkk-riza" /></div>
            <label className="flex items-start gap-2 text-sm">
              <Checkbox checked={!!f.legal_review_done} onCheckedChange={(v) => setF({ ...f, legal_review_done: v === true })} data-testid="yh-kvkk-legal" />
              Bu metinlerin hukuki incelemesi tamamlandı; gerçek müşterilere sunulabilir.
            </label>
            <p className="text-xs text-muted-foreground">Her kayıt yeni sürüm oluşturur. Daha önce verilmiş onaylar, onay anındaki metin sürümüyle saklanır.</p>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose} data-testid="yh-kvkk-close">Kapat</Button>
              <Button onClick={save} disabled={busy} data-testid="yh-kvkk-save" className="rounded-full bg-primary text-[hsl(var(--brand-black))] hover:bg-primary/90 font-bold">Kaydet</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
